// extracted by mini-css-extract-plugin
module.exports = {"ProfilePictureContainer":"ProfilePicture_ProfilePictureContainer__21n-I","ProfilePicture":"ProfilePicture_ProfilePicture__2DZPT"};